import { fireBIEvent } from 'public/bi-event.js';

$w.onReady(function () {
    clickOnPrimaryCtaBiEvent();
    clickOnSupportArticleBiEvent();
    clickOnSecondaryCtaBiEvent();
});

const clickOnPrimaryCtaBiEvent = () => {

    const ctas = [
        '#button118',
        '#button117'
    ]

    ctas.forEach((cta) => {
        $w(cta).onClick(() => {
            const biFields = {
                ctaName: $w(cta).label,
                targetUrl: $w(cta).link,
            }
            fireBIEvent(19, 9001, biFields);
        });
    });

}

const clickOnSupportArticleBiEvent = () => {

    const ctas = [{
            id: '#button69',
            articleCategory: 'Create',
            articleName: $w('#button69').label,
            articleSubCategory: 'Design and edit',
            targetUrl: $w('#button69').link,
        },
        {
            id: '#button78',
            articleCategory: 'Create',
            articleName: $w('#button78').label,
            articleSubCategory: 'Design and edit',
            targetUrl: $w('#button78').link,
        },
        {
            id: '#button68',
            articleCategory: 'Create',
            articleName: $w('#button68').label,
            articleSubCategory: 'Design and edit',
            targetUrl: $w('#button68').link,
        },
        {
            id: '#button67',
            articleCategory: 'Create',
            articleName: $w('#button67').label,
            articleSubCategory: 'Design and edit',
            targetUrl: $w('#button67').link,
        },

        {
            id: '#button72',
            articleCategory: 'Create',
            articleName: $w('#button72').label,
            articleSubCategory: 'Organize your pages',
            targetUrl: $w('#button72').link,
        },
        {
            id: '#button71',
            articleCategory: 'Create',
            articleName: $w('#button71').label,
            articleSubCategory: 'Organize your pages',
            targetUrl: $w('#button71').link,
        },
        {
            id: '#button70',
            articleCategory: 'Create',
            articleName: $w('#button70').label,
            articleSubCategory: 'Organize your pages',
            targetUrl: $w('#button70').link,
        },

        {
            id: '#button75',
            articleCategory: 'Create',
            articleName: $w('#button75').label,
            articleSubCategory: 'Edit for mobile',
            targetUrl: $w('#button75').link,
        },
        {
            id: '#button74',
            articleCategory: 'Create',
            articleName: $w('#button74').label,
            articleSubCategory: 'Edit for mobile',
            targetUrl: $w('#button74').link,
        },
        {
            id: '#button73',
            articleCategory: 'Create',
            articleName: $w('#button73').label,
            articleSubCategory: 'Edit for mobile',
            targetUrl: $w('#button73').link,
        },
        {
            id: '#button43',
            articleCategory: 'Manage',
            articleName: $w('#button43').label,
            articleSubCategory: 'Get a custom domain',
            targetUrl: $w('#button43').link,
        },
        {
            id: '#button42',
            articleCategory: 'Manage',
            articleName: $w('#button42').label,
            articleSubCategory: 'Get a custom domain',
            targetUrl: $w('#button42').link,
        },
        {
            id: '#button41',
            articleCategory: 'Manage',
            articleName: $w('#button41').label,
            articleSubCategory: 'Get a custom domain',
            targetUrl: $w('#button41').link,
        },
        {
            id: '#button39',
            articleCategory: 'Manage',
            articleName: $w('#button39').label,
            articleSubCategory: 'Manage your site',
            targetUrl: $w('#button39').link,
        },
        {
            id: '#button38',
            articleCategory: 'Manage',
            articleName: $w('#button38').label,
            articleSubCategory: 'Manage your site',
            targetUrl: $w('#button38').link,
        },
        {
            id: '#button37',
            articleCategory: 'Manage',
            articleName: $w('#button37').label,
            articleSubCategory: 'Manage your site',
            targetUrl: $w('#button37').link,
        },
        {
            id: '#button36',
            articleCategory: 'Manage',
            articleName: $w('#button36').label,
            articleSubCategory: 'Streamline your workflow',
            targetUrl: $w('#button36').link,
        },
        {
            id: '#button35',
            articleCategory: 'Manage',
            articleName: $w('#button35').label,
            articleSubCategory: 'Streamline your workflow',
            targetUrl: $w('#button35').link,
        },
        {
            id: '#button34',
            articleCategory: 'Manage',
            articleName: $w('#button34').label,
            articleSubCategory: 'Streamline your workflow',
            targetUrl: $w('#button34').link,
        },  
        {
            id: '#button52',
            articleCategory: 'Grow',
            articleName: $w('#button52').label,
            articleSubCategory: 'Optimize your SEO',
            targetUrl: $w('#button52').link,
        },
        {
            id: '#button51',
            articleCategory: 'Grow',
            articleName: $w('#button51').label,
            articleSubCategory: 'Optimize your SEO',
            targetUrl: $w('#button51').link,
        },
        {
            id: '#button50',
            articleCategory: 'Grow',
            articleName: $w('#button50').label,
            articleSubCategory: 'Optimize your SEO',
            targetUrl: $w('#button50').link,
        },
        
        {
            id: '#button49',
            articleCategory: 'Grow',
            articleName: $w('#button49').label,
            articleSubCategory: 'Promote your site',
            targetUrl: $w('#button49').link,
        },
        {
            id: '#button48',
            articleCategory: 'Grow',
            articleName: $w('#button48').label,
            articleSubCategory: 'Promote your site',
            targetUrl: $w('#button48').link,
        },
        {
            id: '#button47',
            articleCategory: 'Grow',
            articleName: $w('#button47').label,
            articleSubCategory: 'Promote your site',
            targetUrl: $w('#button47').link,
        },
        
        {
            id: '#button46',
            articleCategory: 'Grow',
            articleName: $w('#button46').label,
            articleSubCategory: 'Connect with customers',
            targetUrl: $w('#button46').link,
        },
        {
            id: '#button45',
            articleCategory: 'Grow',
            articleName: $w('#button45').label,
            articleSubCategory: 'Connect with customers',
            targetUrl: $w('#button45').link,
        },
        {
            id: '#button44',
            articleCategory: 'Grow',
            articleName: $w('#button44').label,
            articleSubCategory: 'Connect with customers',
            targetUrl: $w('#button44').link,
        },
        

    ];

    ctas.forEach((cta) => {
        const {
            id,
            articleCategory,
            articleName,
            articleSubCategory,
            targetUrl,
        } = cta;
        $w(id).onClick(() => {

            const biFields = {
                articleCategory,
                articleName,
                articleSubCategory,
                targetUrl,
            }
            fireBIEvent(19, 9000, biFields);
        });
    });
}

const watchVideoBiEvent = () => {
    const videos = [
        '#videoPlayer1',
        '#videoPlayer2',
        '#videoPlayer3'
    ]
    videos.forEach((id) => {

        $w(id).onPlay(() => {

            const biFields = {
                videoName: $w(id).title || $w(id).description,
                videoUrl: $w(id).src,

            }
            fireBIEvent(19, 9003, biFields);
        });
    });
}

const clickOnSecondaryCtaBiEvent = () => {
    const ctas = [

        {
            id: '#button21',
            ctaCategory: 'Video',
            ctaName: $w('#button21').label,
            targetUrl: $w('#button21').link
        },
        {
            id: '#text93',
            ctaCategory: 'Create',
            ctaName: $w('#text93').text,
            targetUrl: 'https://support.wix.com/en/the-wix-editor/editor-basics'
        },
        {
            id: '#text96',
            ctaCategory: 'Create',
            ctaName: $w('#text96').text,
            targetUrl: 'https://support.wix.com/en/the-wix-editor/page-structure'
        },
        {
            id: '#text98',
            ctaCategory: 'Create',
            ctaName: $w('#text98').text,
            targetUrl: 'https://support.wix.com/en/the-mobile-editor/getting-started'
        },
        {
            id: '#text64',
            ctaCategory: 'Manage',
            ctaName: $w('#text64').text,
            targetUrl: 'https://support.wix.com/en/article/about-domains'
        },
        {
            id: '#text62',
            ctaCategory: 'Manage',
            ctaName: $w('#text62').text,
            targetUrl: 'https://support.wix.com/en/managing-your-site/site-management'
        },
        {
            id: '#text60',
            ctaCategory: 'Manage',
            ctaName: $w('#text60').text,
            targetUrl: 'https://support.wix.com/en/article/ascend-plans-about-ascend-by-wix'
        },
        
        {
            id: '#text71',
            ctaCategory: 'Grow',
            ctaName: $w('#text71').text,
            targetUrl: 'https://support.wix.com/en/seo-get-found-on-google/get-found-on-google-with-seo-wiz'
        },
        {
            id: '#text69',
            ctaCategory: 'Grow',
            ctaName: $w('#text69').text,
            targetUrl: 'https://support.wix.com/en/marketing-tools/marketing-integrations-tracking'
        },
        {
            id: '#text67',
            ctaCategory: 'Grow',
            ctaName: $w('#text67').text,
            targetUrl: 'https://support.wix.com/en/article/ascend-plans-about-ascend-by-wix'
        },
        
        {
            id: '#button65',
            ctaCategory: 'Support',
            ctaName: $w('#button65').label,
            targetUrl: $w('#button65').link
        },
        {
            id: '#button63',
            ctaCategory: 'Support',
            ctaName: $w('#button63').label,
            targetUrl: $w('#button63').link
        },
        
        {
            id: '#button53',
            ctaCategory: 'Inspiration',
            ctaName: $w('#button53').label,
            targetUrl: $w('#button53').link
        },
        {
            id: '#button54',
            ctaCategory: 'Inspiration',
            ctaName: $w('#button54').label,
            targetUrl: $w('#button54').link
        },
        {
            id: '#button55',
            ctaCategory: 'Inspiration',
            ctaName: $w('#button55').label,
            targetUrl: $w('#button55').link
        },
        
        {
            id: '#image3',
            ctaCategory: 'Inspiration',
            ctaName: 'Image 3',
            targetUrl: $w('#image3').link
        },
        {
            id: '#image2',
            ctaCategory: 'Inspiration',
            ctaName: 'Image 2',
            targetUrl: $w('#image2').link
        },
        {
            id: '#image1',
            ctaCategory: 'Inspiration',
            ctaName: 'Image 1',
            targetUrl: $w('#image1').link
        },
        
        {
            id: '#button19',
            ctaCategory: 'Manage',
            ctaName: $w('#button19').label,
            targetUrl: $w('#button19').link
        },
        {
            id: '#button18',
            ctaCategory: 'Create',
            ctaName: $w('#button18').label,
            targetUrl: $w('#button18').link
        },
        {
            id: '#button20',
            ctaCategory: 'Grow',
            ctaName: $w('#button20').label,
            targetUrl: $w('#button20').link
        },
        
        {
            id: '#text80',
            ctaCategory: 'Inspiration',
            ctaName: $w('#text80').text,
            targetUrl: 'https://www.wix.com/blog/2020/12/small-business-website-design-tips/'
        },
        {
            id: '#text81',
            ctaCategory: 'Inspiration',
            ctaName: $w('#text81').text,
            targetUrl: 'https://www.wix.com/blog/creative/2018/09/best-website-designs'
        },
        {
            id: '#text82',
            ctaCategory: 'Inspiration',
            ctaName: $w('#text82').text,
            targetUrl: 'https://www.wix.com/blog/2021/02/how-to-make-a-website/'
        },
        
        // {
        //     id: '#text85',
        //     ctaCategory: 'Success stories',
        //     ctaName: $w('#text85').text,
        //     targetUrl: 'https://www.youtube.com/watch?v=fFKcSeh9Uz8&ab_channel=Wix.com'
        // },
        // {
        //     id: '#text100',
        //     ctaCategory: 'Success stories',
        //     ctaName: $w('#text100').text,
        //     targetUrl: 'https://www.youtube.com/watch?v=vUxMofJj9is&ab_channel=Wix.com'
        // },
        // {
        //     id: '#text83',
        //     ctaCategory: 'Success stories',
        //     ctaName: $w('#text83').text,
        //     targetUrl: 'https://www.youtube.com/watch?v=b4X7-6bWxzg&ab_channel=Wix.com'
        // },

    ];

    ctas.forEach((cta) => {
        const {
            id,
            ctaCategory,
            ctaName,
            targetUrl,
        } = cta;
        $w(id).onClick(() => {

            const biFields = {
                ctaCategory,
                ctaName,
                targetUrl,
            }
            fireBIEvent(19, 9002, biFields);
        });
    });
}